import { DialogResultVm } from "../../checkresultdialog/dialogresultvm";
import { ServiceProvider } from "../provider/service-provider";
import { ErrorHelper } from "../error";
import * as DbTypes from "../../types/shared-dbtypes";
import { Logger } from "../../logger/logger";
import { UrlHelper } from "../html/url-helper";
import { MessageHelper } from "../../helper/message-helper";
import { CheckResultData } from "../../checkresultdialog/checkresultdata";
import { AjaxParams } from "../provider/provider-interfaces";

export class ModuleHelper {
	public static openModuleByClassIdAsync = async (classId: number, objectId: number) => {
		let url = UrlHelper.getDataUrl("modulepath-byclass");
		let params = { classId, objectId };
		return ModuleHelper.openModuleAsync(url, params);
	}

	public static getModuleTarget(modId: number | string) {
		// TODO(jpg): es sollte ein hash genommen werden, der bei den unterschiedlichen Instancen/Datenbanken unterschiedlich ist
		// Beispiel: Wenn man das Kampagnenmodul zum Vergleich auf zweich verschiedenen Instanzen öffnet, sollten auch 2 verschiedene Fenster aufgehen
		return `mod_${UrlHelper.getApplicationInstanceHash()}_${modId}`;
	}

	public static getObjectLinkResultsByClassIdAsync = async (classId: number, objectId: number) => {
		let url = UrlHelper.getDataUrl("objectlinkresults-byclass");
		let params = { classId, objectId };
		return ModuleHelper.getObjectLinkResultsAsync(url, params);
	}

	public static openWindow = (path: string, target: string, isResolved?: boolean) => {
		let url = ModuleHelper.resolvePath(path, isResolved);

		let win = window.open(url, target);
		if (win) {
			win.focus();
		} else {
			Logger.warn(`Could not open window with path: ${url} and target: ${target}`);
		}
	}

	public static resolvePath(path: string, isResolved?: boolean) {
		let url = `${UrlHelper.getBaseUrl()}${path}`;
		if (isResolved) {
			url = path;
		}

		return url;
	}

	public static openWindowInSameTab = (path: string, isResolved?: boolean) => {
		ModuleHelper.openWindow(path, "_self", isResolved);
	}

	public static openWindowInNewTab = (path: string, isResolved?: boolean) => {
		ModuleHelper.openWindow(path, "_blank", isResolved);
	}

	private static getObjectLinkResultsAsync = async (url: string, params: AjaxParams) => {
		let result: DbTypes.IObjectLinkResult[] = [];
		let data: CheckResultData = await ServiceProvider.ajax.getJsonNoCacheAsync({ url, params }).catch((err) => {
			Logger.warn(`Could not get object link result for url '${url}'`, err);
			return null;
		});

		if (data && data.success) {
			if (data.resultData && data.resultData.items) {
				Logger.warn("Refactoring getObjectLinkResultAsync should not contain items, please check");
			}
			result = data.resultData;
		}

		return result;
	}

	private static openModuleAsync = async (url: string, params: AjaxParams) => {
		let data: CheckResultData = await ServiceProvider.ajax.getJsonNoCacheAsync({ url, params }).catch((err) => {
			DialogResultVm.showErrorDialog("Modul starten", [`Das Modul konnte nicht gestartet werden: ${ErrorHelper.toString(err)}`]);
			return null;
		});

		if (data && data.success) {
			let objectLinkResult: DbTypes.IObjectLinkResult = data.resultData;
			if (objectLinkResult) {
				ModuleHelper.openWindowInNewTab(objectLinkResult.path, !objectLinkResult.isRelative);
			} else {
				MessageHelper.uiError("Die Aktion ist fehlgeschlagen");
			}
		} else {
			DialogResultVm.showDialog(data);
		}
	}

	private constructor() { }
}